import { BaseChartKeySelectionStrategy } from '@root/Components/DataGrid/BaseChartKeySelectionStrategy';
import { DailyInvoiceRow } from '@root/Components/Invoices/DailyInvoiceGrid';
import { MonthlyInvoiceRow } from '@root/Components/Invoices/MonthlyInvoicesGrid';

export class ChartKeySelectionStrategy extends BaseChartKeySelectionStrategy<MonthlyInvoiceRow> {}
export class ChartKeySelectionStrategyDaily extends BaseChartKeySelectionStrategy<DailyInvoiceRow> {}
